import { Component } from '@angular/core';
import { faRobot } from '@fortawesome/pro-light-svg-icons';
import { faBolt } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'hcr-robot-icon',
  templateUrl: './robot-icon.component.html',
  styleUrls: ['./robot-icon.component.sass'],
})
export class RobotIconComponent {
  public icons = {
    robot: faRobot,
    bolt: faBolt,
  };
}
